import { ThresholdBar } from '../../../core/components/threshold-bar/ThresholdBar.js';
import { DateThresholdPosition } from '../../../core/types/thresholds.js';
import { transformThresholdsToMarkers } from '../../../core/utils/threshold-to-marker.js';
import { useSetState } from '../../hooks/store/selectors.js';
import { useThresholdConfig } from '../../hooks/useThresholdConfig.js';
import { useTimeseriesYFormatter } from '../../hooks/useTimeseriesYFormatter.js';
import { useXScales } from '../../hooks/useXScale.js';
import { useYScales } from '../../hooks/useYScales.js';

interface TimeseriesThresholdBarProps {
  position: DateThresholdPosition;
  length: number;
}

export function TimeseriesThresholdBar(props: TimeseriesThresholdBarProps) {
  const { position, length } = props;

  const { left: leftThreshold, right: rightThreshold } = useThresholdConfig();
  const { left, right } = useYScales();
  const { currentScale } = useXScales();
  const [leftFormatter, rightFormatter] = useTimeseriesYFormatter();
  const setState = useSetState();

  const isFlipped = position !== 'left';

  const yScale = position === 'left' ? left : right;
  if (!yScale) {
    return null;
  }

  const thresholds = position === 'left' ? leftThreshold : rightThreshold;
  if (!thresholds || !thresholds.length) {
    return null;
  }

  const axisFormatter = position === 'left' ? leftFormatter : rightFormatter;

  const markers = thresholds.reduce(
    transformThresholdsToMarkers(
      position,
      currentScale,
      yScale.scale,
      axisFormatter,
    ),
    [],
  );

  const handleHover = (id: string | undefined) => {
    setState((prev) => ({
      ...prev,
      thresholds: {
        ...thresholds,
        hoveredThresholdId: id,
      },
    }));
  };
  return markers.length ? (
    <ThresholdBar
      markers={markers}
      length={length}
      layout="vertical"
      isFlipped={isFlipped}
      onHover={handleHover}
    />
  ) : null;
}

TimeseriesThresholdBar['displayName'] = 'TimeseriesThresholdBar';
